// extracted by mini-css-extract-plugin
export default {"emptyDescription":"PackFilling_emptyDescription__cw52w","downloadDescription":"PackFilling_downloadDescription__839bH"};